import styled from "styled-components";
import { colors } from '../helpers/consts'

const ItemsList = styled.ul`
  padding: 2rem 3rem;
  font-size: 1.4rem;
  line-height: 1.4;
  color: #7c8595;
  margin-bottom: 1rem;
  padding: 1rem 0 0 2rem;

  @media (min-width: 48em) {
    font-size: 1.5rem;
    margin-bottom: 1.6rem;
  }

  @media (min-width: 62em) {
    font-size: 1.7rem;
    margin-bottom: 2.5rem;
  }
`

const ListItem = styled.li`
  margin-bottom: 0.4rem;
  position: relative;
  font-size: 1.4rem;
  line-height: 1.4;
  color: ${colors.darkBlue};

  @media (min-width: 48em) {
    font-size: 1.5rem;
  }

  @media (min-width: 62em) {
    font-size: 1.6rem;
  }
`

const SquereListItem = styled(ListItem)`
  &::before {
    content: '';
    background-color: ${colors.orange};
    border-radius: 50%;
    width: 1rem;
    height: 1rem;
    position: absolute;
    top: 0.6rem;
    left: -2rem;
  }
`

export const NumListItem = styled(ListItem)`
  ::marker {
    font-family: 'Montserrat', sans-serif;
    font-size: 1.6rem;
    color: ${colors.darkBlue};

    @media (min-width: 48em) {
      font-size: 1.5rem;
    }

    @media (min-width: 62em) {
      font-size: 1.6rem;
    }
  }
`

const NumList = styled.ol`
  padding: 2rem 3rem;
  font-size: 1.4rem;
  line-height: 1.4;
  margin-bottom: 1rem;
  padding: 1rem 0 0 2rem;

  @media (min-width: 48em) {
    font-size: 1.5rem;
    margin-bottom: 1.6rem;
  }

  @media (min-width: 62em) {
    font-size: 1.6rem;
    margin-bottom: 2.5rem;
  }
`

const List = ({ list, isNum }) => isNum ? <NumList>
    {list.map(el => <NumListItem key={el}>{el}</NumListItem>)}
  </NumList> : <ItemsList>
    {list.map(el => <SquereListItem key={el}>{el}</SquereListItem>)}
  </ItemsList>

export default List